import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';
import constants from '$$helpers/constants';
import resourcesOverload from '../../resourcesOverload';
import {
  prepareTaskToRefresh,
  createCommentsHelper,
  createAttachmentsHelper,
  askJiraCustomColumnsAfterCreate,
} from './helpers';

function onTaskCreated(event) {
  const tasksToCreate = [];
  const tasksCustomValues = [];
  const userCustomValues = [];
  const resourcesToTasksForCommit = [];

  event.data.tasks.forEach(task => {
    const newTask = prepareTaskToRefresh(task);
    const projectData = globalStore.getters['tasksModel/getItem'](newTask.gantt_id);

    if (!projectData) {
      return;
    }

    if (newTask.attachments.length) {
      createAttachmentsHelper(newTask.attachments);

      newTask.hasAttachments = newTask.attachments.length;
    }

    if (newTask.comments.length) {
      createCommentsHelper(newTask.comments);

      newTask.hasComments = newTask.comments.length;
      newTask.newComments = 1;
    }

    newTask.open = 1;

    if (newTask.status || newTask.priority) {
      tasksCustomValues.push({
        ganttId: +newTask.gantt_id,
        taskId: +newTask.id,
        taskCustomValues: _.pick(newTask, ['status', 'priority']),
      });
    }

    if (newTask.customFields?.length) {
      const customFields = [];

      newTask.customFields.forEach(item => {
        let value;

        if (item.value !== null) {
          if (item.type === 'checkbox') {
            item.value = item.value ? 1 : 0;
          }

          if (Array.isArray(item.value)) {
            value = item.value.map(el => el.id);
          } else if (typeof item.value === 'object') {
            value = item.value.id;
          } else {
            value = item.value;
          }

          customFields.push({ customColumnId: +item.id, value });
        }
      });

      if (customFields.length) {
        userCustomValues.push({ taskId: +newTask.id, ganttId: +newTask.gantt_id, customFields });
      }
    }

    if (newTask.resources?.length) {
      newTask.resources = newTask.resources.map(resource => {
        let isTimeTypeResource = false;
        const storeResource = globalStore.getters['resourcesModel/getResourceById'](resource.resourceId);

        if (storeResource) {
          storeResource.resourceProjects.forEach(storeResourceProject => {
            if (storeResourceProject.projectId === task.projectId && storeResourceProject.type === constants.RESOURCE_TIME_TYPE) {
              isTimeTypeResource = true;
            }
          });
        }

        return {
          custom_days: [],
          resource_id: +resource.resourceId,
          task_id: task.id,
          value: isTimeTypeResource ? resource.resourceValue / 60 : resource.resourceValue,
        };
      });

      resourcesToTasksForCommit.push({ taskId: task.id, ganttId: newTask.gantt_id, resourcesToTask: _.cloneDeep(newTask.resources) });
    }

    tasksToCreate.push(newTask);
  });

  if (tasksToCreate.length) {
    globalStore.commit('tasksModel/addTasks', { tasks: tasksToCreate, fromGantt: false }, { root: true });
  }

  if (!_.isEmpty(tasksCustomValues)) {
    globalStore.commit('tasksModel/updateTasksCustomValues', { tasksCustomValues, fromGantt: false }, { root: true });
  }

  if (!_.isEmpty(userCustomValues)) {
    globalStore.commit('columns/updateUserCustomValues', { userCustomValues, fromGantt: false }, { root: true });
  }

  if (!_.isEmpty(resourcesToTasksForCommit)) {
    globalStore.commit('tasksModel/updateResourcesToTasks', { resourcesToTasks: resourcesToTasksForCommit, fromGantt: false }, { root: true });
    resourcesOverload.refreshCache();
  }

  if (event.requestId && event.requestId.slice(36) === 'jira') {
    askJiraCustomColumnsAfterCreate(event.data.tasks);
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.tasks.map(i => i.id),
    tasksData: event.data.tasks,
    projects: event.data.tasks.map(i => i.projectId),
  });
}

export default onTaskCreated;
